<template>
    <div class="bg">
        <div id="main" class="container">
            <loader v-if="isLoading" />
            <alert-container :messages="msgs" />
            <div class="listing-header mb-3">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t( !this.isEdit ? 'vincular-feriado' : 'alterar-feriado') }}
                    </h1>
                </div>
                <div class="header-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="onFecharModal"    
                    >
                        {{ $t("cancelar") }}
                    </button>
                    <button
                        class="save-btn"
                        type="button"
                        @click="insert"
                        :disabled="feriadosSelecionados.length === 0 && !isEdit"
                    >
                        {{ $t("salvar") }}
                    </button>
                </div>
            </div>
            <div class="form-columns-fit">
                <div class="columns is-flex-wrap">
                    <div class="column is-6">
                        <vss-select
                            :title="'trabalha-feriado'"
                            :options="trabalhaFeriadoSelect"
                            v-model="trabalhaFeriadoSelected"
                            :onChange="updateTrabalhaFeriado"
                            mlLabels
                        />
                    </div>
                </div>
            <div class="search-and-filter" v-if="!isEdit">
                <div class="search-bar">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                    />
                </div>
            </div>

            <div class="registry-wrapper" v-if="!isEdit">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="feriados"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                    checkable
                    :checked-rows.sync="feriadosSelecionados"
                    :custom-is-checked="(selecionados, linha) => selecionados.idferiado === linha.idferiado">
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="$t(f.key)"
                        :width="f.width"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                        >
                        <span>{{ props.row[f.key] }}</span>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
        </div>
    </div>
</template>

<script>
// SERVICES
import FeriadoService from "@/services/FeriadosService";
import AssTurnoFeriadoService from "@/services/AssTurnoFeriadoService";

// MENSAGENS
import Message from "@/models/Message";

export default {
    props: {
        idTurno: 0,
        selected: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            service: new FeriadoService(this.$http, this.$router),
            assTurnoFeriadoservice: new AssTurnoFeriadoService(this.$http, this.$router),
            feriados: [],
            isLoading: false,
            isEmpty: false,
            isEdit: false,
            assturnoferiado: {},
            fields: [
                {key: 'descricao', width: null, sortable: true, sortFn: null},
                {key: 'data', width: null, sortable: true, sortFn: null},
            ],
            feriadosSelecionados: [],
            idturno: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,   
                currentPage: 1,
            },
            trabalhaFeriadoSelect: [
                { id: 0, label: "nao" },
                { id: 1, label: "sim" },
            ],
            trabalhaFeriadoSelected: {id: 1, label: "sim"},
            column: 'descricao',
            order: 'asc',
            msgs: [],
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        if(this.selected){
            this.isEdit = true
            this.loadAssFeriadoTurno()
        } else {
            this.isEdit = false
        }
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }
            this.isLoading = true;
            this.service
            .findAllNaoAssociadosByTurno(
                    this.$route.params.id,
                    1,
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.queryFilter,
            )
            .then(this.mapItems)
            .then(value => {
                this.feriados = value;
                this.isEmpty = this.feriados.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },

        generateId(numberId){
            return this.$route.name+'-turno-'+numberId;
        },
        multiplicadorUpdate(value){
            this.multiplicadorweb = value;
        },
        multiplicadortrocaUpdate(value){
            this.multiplicadortrocaweb = value;
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map(m => {
                return {
                    idferiado: m.idferiado,
                    descricao: m.descricao,
                    data: m.dataformatada
                };
            });
        },
        loadAssFeriadoTurno() {
            this.trabalhaFeriadoSelected = this.trabalhaFeriadoSelect[this.selected.trabalhaferiado]

        },
        mapFeriadoTurno(item) {
            this.assturnoferiado.idassturnoferiado = item.idassturnoferiado
            this.assturnoferiado.idferiado = item.idferiado
            this.assturnoferiado.nome = item.nome
            this.trabalhaFeriadoSelected.id = this.trabalhaFeriadoSelect[item.trabalhaferiado]
        },
        mapOnSave(itens) {
            return itens.map(m => {
                return {
                    idassturnoferiado: m.idassturnoferiado,
                    idturno: this.$route.params.id,
                    idferiado: m.idferiado,
                    trabalhaferiado: this.trabalhaFeriadoSelected.id
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        insert() {
            if (this.isEdit){
                this.update()
            }else{
                this.save()
            }
        },
        save() {
            if (this.feriadosSelecionados.length > 0 || this.isEdit) {
                this.isLoading = true;
                this.assTurnoFeriadoservice.saveBulk(this.mapOnSave(this.feriadosSelecionados))
                .then(value => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.onFecharModal()
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            }
        },
        mapOnUpdate(item) {
            return {
                idassturnoferiado: item.idassturnoferiado,
                idturno: this.$route.params.id,
                idferiado: item.idferiado,
                trabalhaferiado: this.trabalhaFeriadoSelected.id
            }
        },
        update() {
            this.isLoading = true;
            this.assTurnoFeriadoservice.update(this.mapOnUpdate(this.selected))
            .then(value => {
                if (value.content === null) {
                    this.msgs.push(new Message("error", `${value.message}`, true));
                } else {
                    this.onFecharModal()
                    this.$root.showMessage('success', 'msg-sucesso-alterar');
                }
            })
            .catch((e) => {
                this.msgs.push(new Message("alert", 'msg-erro-load', true));
            })
            .finally(() => {
                this.isLoading = false;
            });
        },
        onFecharModal(){
            this.isEdit = false
            this.$emit('fecharModal',true);
        },
        updateTrabalhaFeriado(trabalhaFeriado){
            this.trabalhaFeriadoSelected = this.$t(trabalhaFeriado)
        }
    },
}
</script>


<style lang="scss" scoped>
.container {
    min-height: 200px;
}
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 1060px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}

</style>